<script lang="ts">
  import Dialog from "./Dialog.svelte";
  import SharepointFileInput from "./SharepointFileInput.svelte";
  import Form from "./Form.svelte";
  import Upload from "~icons/ph/upload-simple";
  import RevealDocuments from "./RevealDocuments.svelte";
  import { lockScroll, unlockScroll } from "../behaviors/lockScroll";
  import { onDestroy } from "svelte";

  let {
    matterUrls,
    allowedExtensions,
    errors,
    uploadedDocuments
  }: {
    matterUrls: [string, string[]][];
    allowedExtensions: string[];
    errors: string[];
    uploadedDocuments: {name: string, type: string, created_at: string, matter_label: string | null}[] | [];
  } = $props();

  let multiple = $derived(matterUrls.length > 1);
  let dialog = $state<Dialog>();
  let dialogId = $state(0); // Reset Dialog upon closing to allow user to chose other matter
  let fileInput = $state<SharepointFileInput>();
  let selectedMatterUrls = $state(null);
  let [createUploadSessionUrl, attachDocumentsUrl] = $derived(selectedMatterUrls || ["",""]);
  reset();

  function reset() {
    dialogId += 1;
    selectedMatterUrls = multiple ? "" : matterUrls[0][1];
    errors = [];
  }
  function handleClose(_) {
    fileInput?.cancelAll();
    reset();
    unlockScroll();
  }

  function openModal() {
    dialog?.showModal();
    lockScroll();
  }

  function closeModal() {
    dialog?.close();
  }

  onDestroy(unlockScroll);
</script>

<div class="rounded bg-white p-4 pl-3 lg:p-6 lg:pl-5 border-l-4 border-0 border-solid border-info">
  <h2 class="ui-title mb-1">Add additional files</h2>
  <p class="text-gray-600 mb-4">Upload any documents, records, or photos that may help your case.</p>

  <button class="btn btn-secondary w-full sm:w-auto" type="button" onclick={openModal}>
    <Upload class="w-4 h-4 relative -top-[1px]" />
    Upload
  </button>

  {#if uploadedDocuments.length !== 0}
    <RevealDocuments label="Uploaded files" documents={uploadedDocuments} displayMatterLabel={true} class="mt-4" />
  {/if}
</div>

{#key dialogId}
  <Dialog bind:this={dialog} onclose={handleClose} autofocus={!multiple}>
    <Form action={attachDocumentsUrl} method="post" class="flex flex-col gap-4">
      <h2 class="font-medium text-lg">Upload additional files</h2>
      {#if multiple}
        <!-- svelte-ignore a11y_autofocus -->
        <select
          bind:value={selectedMatterUrls}
          class="ui-select"
          autofocus
          required
          disabled={fileInput?.hasFiles}
        >
          <option value="">Which case is this file for?</option>
          {#each matterUrls as [label, urls]}
            <option value={urls}>{label}</option>
          {/each}
        </select>
      {/if}
      {#if createUploadSessionUrl}
        <SharepointFileInput
          bind:this={fileInput}
          name={"additional_document"}
          accept={allowedExtensions}
          {createUploadSessionUrl}
          required={true}
          multiple={true}
        />
        <input
          name="optional_note"
          type="text"
          placeholder="Add a note (optional)"
          class="input input-bordered w-full"
        />
        {#if errors?.length}
          <div class="text-error">{errors.join(". ")}</div>
        {/if}
      {/if}
      <div class="flex justify-between">
        <button class="btn btn-ghost" type="button" onclick={closeModal}>Cancel</button>
        <button class="btn btn-primary" type="submit">Send</button>
      </div>
    </Form>
  </Dialog>
{/key}
